<div class="flex h-full cursor-pointer border-primary border-dashed border-1" [ngStyle]="{'min-height': '20rem'}"
    (click)="fileInput.click()" appDragDrop (onFileDropped)="uploadFile($event)" [disabled]="disabled">
    <div class="flex m-auto">
        <div class="w-full">
            <div class="flex upload rounded-lg shadow-sm">
                <input hidden type="file" accept=".csv" multiple #fileInput (change)="uploadFile($event.target.files)" [disabled]="disabled">
                <div class="m-auto">
                    <div class="icon w-full flex">
                        <i class="pi pi-cloud-upload m-auto" style="color: var(--primary-color); font-size: 4rem;"></i>
                    </div>
                    <div class="text-center mt-4">
                        <p>{{'uploadCsv.dragAndDrop' | transloco}}</p>
                        <div class="flex mb-3 text-center">
                            <span class="w-full" style="border-bottom: 1px solid var(--custom-gray); line-height: 0.1em">
                            </span>
                            <span class="pl-2 pr-2" style="line-height: 0.2em">{{'uploadCsv.or' | transloco}}</span>
                            <span class="w-full" style="border-bottom: 1px solid var(--custom-gray); line-height: 0.1em">
                            </span>
                        </div>
                        <button pButton class="md:mr-2 p-button-primary my-2 md:mb-0">
                            {{'uploadCsv.chooseFiles' | transloco}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
